import React from "react";
import { liveAuctions } from "../../../data/liveAuctions.json";
import useToggle from "../../../hooks/useToggle";
import GoToTop from "../../Helpers/GoToTop";
import Drawer from "../../Mobile/Drawer";
import FooterOne from "../../Partials/Footers/FooterOne";
import HeaderOne from "../../Partials/Headers/HeaderOne";
import MainSection from "./MainSection";
import UserDetails from "./UserDetails";

function Activity() {
  const [drawer, setDrawer] = useToggle(false);
  return (
    <>
      <Drawer drawer={drawer} action={setDrawer.toggle} />
      <HeaderOne className="shop-page-header" action={setDrawer.toggle} />
      <UserDetails />
      <MainSection products={liveAuctions} />
      <FooterOne />
      <GoToTop />
    </>
  );
}

export default Activity;
